import { CaretUpFilled, CaretDownFilled } from '@ant-design/icons'
import { Space, Button } from 'antd'
import { ArrowButtonsProps } from './types'

const ArrowButtons: React.FC<ArrowButtonsProps> = ({ index, move, length }) => {
  return (
    <Space size="small">
      <Button
        icon={<CaretUpFilled />}
        disabled={index === 0}
        shape="circle"
        onClick={(event) => {
          move(index, index - 1)
          event.stopPropagation()
        }}
      />
      <Button
        icon={<CaretDownFilled />}
        disabled={index === length - 1}
        shape="circle"
        onClick={(event) => {
          move(index, index + 1)
          event.stopPropagation()
        }}
      />
    </Space>
  )
}

export default ArrowButtons
